<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="bannerForm" label-width="auto" label-position="right">
      <el-form-item label="banner图片：">
        <div>
          <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
          <div class="add" @click="headImgUpdate" v-else>
            <span>+</span>
          </div>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
        </div>
      </el-form-item>
      <el-form-item label="名称：">
        <el-input v-model="bannerForm.title" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="跳转类型：">
        <el-radio v-model="type" :label="0">不跳转</el-radio>
        <el-radio v-model="type" :label="1">web跳转</el-radio>
        <el-radio v-model="type" :label="2">内部跳转</el-radio>
      </el-form-item>
      <el-form-item label="URL地址：">
        <el-input v-model="bannerForm.url" placeholder="请输入url地址"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="bannerForm.orderNum" placeholder="数字越大越靠前" :maxlength="11"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" :disabled="loading" v-loading="loading" >确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { addOrUpdateBanner} from "@/api/url";
import { phoneReg, greaterIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      bannerForm: this.value.bannerForm,
      idx: this.value.ids,

      files: null,
      src: this.value.bannerForm.img,
      type: this.value.ids>-1?this.value.bannerForm.type:0,
      loading: false
    }
  },
  methods: {

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.bannerForm.files && !this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'banner图片不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.bannerForm.title) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.bannerForm.url && this.type > 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'URL地址不能为空',
          type: 'warning'
        });
        return false
      }
      if(!greaterIntReg.test(this.bannerForm.orderNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      param.append('id', this.idx > -1?this.bannerForm.id:0);
      param.append('title', this.bannerForm.title);
      param.append('type', this.type);
      param.append('url', this.bannerForm.url?this.bannerForm.url:'');
      param.append('orderNum', this.bannerForm.orderNum);
      param.append('file', this.files);

      imgPostFormData(addOrUpdateBanner, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
